var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{class:`my-button my-background-primary my-btn-${_vm.variant} ${_vm.shadow ? 'my-box-shadow-primary' : ''} ${_vm.block ? 'block' : ''}`},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }